export const SumerLensAbi = [
  {
    inputs: [
      {
        internalType: 'contract ICToken',
        name: 'cToken',
        type: 'address',
      },
    ],
    name: 'cTokenMetadata',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'cToken', type: 'address' },
          {
            internalType: 'uint256',
            name: 'exchangeRateCurrent',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'supplyRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'borrowRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'reserveFactorMantissa',
            type: 'uint256',
          },
          { internalType: 'uint256', name: 'totalBorrows', type: 'uint256' },
          { internalType: 'uint256', name: 'totalReserves', type: 'uint256' },
          { internalType: 'uint256', name: 'totalSupply', type: 'uint256' },
          { internalType: 'uint256', name: 'totalCash', type: 'uint256' },
          { internalType: 'bool', name: 'isListed', type: 'bool' },
          {
            internalType: 'address',
            name: 'underlyingAssetAddress',
            type: 'address',
          },
          { internalType: 'uint256', name: 'cTokenDecimals', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'underlyingDecimals',
            type: 'uint256',
          },
          { internalType: 'bool', name: 'isCToken', type: 'bool' },
          { internalType: 'bool', name: 'isCEther', type: 'bool' },
          { internalType: 'uint256', name: 'borrowCap', type: 'uint256' },
          { internalType: 'uint256', name: 'depositCap', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'heteroLiquidationIncentive',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'homoLiquidationIncentive',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'sutokenLiquidationIncentive',
            type: 'uint256',
          },
          { internalType: 'uint8', name: 'groupId', type: 'uint8' },
          { internalType: 'uint256', name: 'intraRate', type: 'uint256' },
          { internalType: 'uint256', name: 'interRate', type: 'uint256' },
          { internalType: 'uint256', name: 'mintRate', type: 'uint256' },
          { internalType: 'uint256', name: 'discountRate', type: 'uint256' },
          { internalType: 'bool', name: 'interMintAllowed', type: 'bool' },
        ],
        internalType: 'struct SumerLens.CTokenMetadata',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract ICToken[]',
        name: 'cTokens',
        type: 'address[]',
      },
    ],
    name: 'cTokenMetadataAll',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'cToken', type: 'address' },
          {
            internalType: 'uint256',
            name: 'exchangeRateCurrent',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'supplyRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'borrowRatePerBlock',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'reserveFactorMantissa',
            type: 'uint256',
          },
          { internalType: 'uint256', name: 'totalBorrows', type: 'uint256' },
          { internalType: 'uint256', name: 'totalReserves', type: 'uint256' },
          { internalType: 'uint256', name: 'totalSupply', type: 'uint256' },
          { internalType: 'uint256', name: 'totalCash', type: 'uint256' },
          { internalType: 'bool', name: 'isListed', type: 'bool' },
          {
            internalType: 'address',
            name: 'underlyingAssetAddress',
            type: 'address',
          },
          { internalType: 'uint256', name: 'cTokenDecimals', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'underlyingDecimals',
            type: 'uint256',
          },
          { internalType: 'bool', name: 'isCToken', type: 'bool' },
          { internalType: 'bool', name: 'isCEther', type: 'bool' },
          { internalType: 'uint256', name: 'borrowCap', type: 'uint256' },
          { internalType: 'uint256', name: 'depositCap', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'heteroLiquidationIncentive',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'homoLiquidationIncentive',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'sutokenLiquidationIncentive',
            type: 'uint256',
          },
          { internalType: 'uint8', name: 'groupId', type: 'uint8' },
          { internalType: 'uint256', name: 'intraRate', type: 'uint256' },
          { internalType: 'uint256', name: 'interRate', type: 'uint256' },
          { internalType: 'uint256', name: 'mintRate', type: 'uint256' },
          { internalType: 'uint256', name: 'discountRate', type: 'uint256' },
          { internalType: 'bool', name: 'interMintAllowed', type: 'bool' },
        ],
        internalType: 'struct SumerLens.CTokenMetadata[]',
        name: '',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'contract ICToken',
        name: 'cToken',
        type: 'address',
      },
      {
        internalType: 'address payable',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'cTokenBalances',
    outputs: [
      {
        components: [
          { internalType: 'address', name: 'cToken', type: 'address' },
          { internalType: 'bool', name: 'isCToken', type: 'bool' },
          { internalType: 'bool', name: 'isCEther', type: 'bool' },
          { internalType: 'uint256', name: 'balanceOf', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'borrowBalanceCurrent',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'balanceOfUnderlying',
            type: 'uint256',
          },
          { internalType: 'uint256', name: 'tokenBalance', type: 'uint256' },
          {
            internalType: 'uint256',
            name: 'tokenAllowance',
            type: 'uint256',
          },
        ],
        internalType: 'struct SumerLens.CTokenBalances',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const

export const SumerComptrollerAbi = [
  {
    inputs: [
      { internalType: 'uint8', name: 'groupId', type: 'uint8' },
    ],
    name: 'assetGroup',
    outputs: [
      {
        components: [
          { internalType: 'uint8', name: 'groupId', type: 'uint8' },
          {
            internalType: 'uint16',
            name: 'intraCRatePercent',
            type: 'uint16',
          },
          {
            internalType: 'uint16',
            name: 'intraMintRatePercent',
            type: 'uint16',
          },
          {
            internalType: 'uint16',
            name: 'intraSuRatePercent',
            type: 'uint16',
          },
          {
            internalType: 'uint16',
            name: 'interCRatePercent',
            type: 'uint16',
          },
          {
            internalType: 'uint16',
            name: 'interSuRatePercent',
            type: 'uint16',
          },
        ],
        internalType: 'struct IComptroller.CompactAssetGroup',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const
